import { Component, OnInit, Input, OnChanges, SimpleChange, SimpleChanges} from '@angular/core';
import { map } from 'rxjs/operators';
import { Customer } from '../salary';
import {SalaryService } from '../salary.service';

@Component({
  selector: 'app-salary-list',
  templateUrl: './salary-list.component.html',
  styleUrls: ['./salary-list.component.css']
})
export class SalaryListComponent implements OnInit, OnChanges {
  @Input() customer: Customer[];
  customers: any;

  totalValue = 0;
  salaryTotal = 0;
  constructor(private customerService: SalaryService) { }

  ngOnChanges(changes: SimpleChanges) {
    const dataChanges: SimpleChange = changes.customer;

    const customers: Customer[] = dataChanges.currentValue;
    this.totalValue = 0;
    customers.forEach(customer => {
      this.totalValue += customer.amount;
    });
  }


  ngOnInit() {
    this.getCustomersList();
  }


  getCustomersList() {
    // Use snapshotChanges().map() to store the key
    this.customerService.getCustomersList().snapshotChanges().pipe(
      map(changes =>
        changes.map(c => ({ key: c.payload.key, ...c.payload.val() }))
      )
    ).subscribe(customers => {
      this.customers = customers;
    });
  }

  deleteCustomers() {
    this.customerService.deleteAll();
  }

}
